import state from './Product/states'
import mutations from './Product/mutations'
import actions from './Product/actions'
import getters from './Product/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
